import { parseApiDate, APIDateFormats } from '../../../utils/Date.js';
import { TrackingStatusInfoMapper } from '../TrackingStatus/TrackingStatusInfoMapper.js';
import { TrackingLocationMapper } from '../TrackingLocation/TrackingLocationMapper.js';

class TrackingCheckpointMapper {
  static createModelFromResponse(data) {
    if (!data) {
      return undefined;
    }
    return {
      status: data.status,
      statusInfo: TrackingStatusInfoMapper.createModelFromResponse(data.status_info),
      rawCarrierStatus: data.raw_carrier_status,
      location: TrackingLocationMapper.createModelFromResponse(data.location),
      occurredAt: parseApiDate(data.occurred_at, APIDateFormats.complete)
    };
  }
}

export { TrackingCheckpointMapper };
//# sourceMappingURL=TrackingCheckpointMapper.js.map
